import React, { useState } from 'react'
import StockZaka from './Calculators/StockZaka'
import AnamZaka from './Calculators/AnamZaka'
import GoldZaka from './Calculators/GoldZaka'
import MoneyZaka from './Calculators/MoneyZaka'
import ZakaCalcTaps from './Partials/ZakaCalcTaps'

function ZakaCalcComponent() {

    const [activeComponent, setActiveComponent] = useState('Stock');

    return (
        <>
            <div className="flex flex-col px-5 mt-20">
                <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                    حاسبة الزكاة
                </div>
                <div className="self-start mt-4 text-lg text-right text-zinc-900 max-md:max-w-full">
                    لزكاة نسبة من المال يجب إخراجها لمساعدة الفقراء والمحتاجين، وهو ركن من
                    أركان الإسلام الخمسة، وواجب على جميع المسلمين، فقد قال الله
                    &quot;وَأَقِيمُوا الصَّلَاةَ وَآتُوا الزَّكَاةَ وَارْكَعُوا مَعَ
                    الرَّاكِعِينَ&quot; ﴿البقرة: ٤٣﴾.
                </div>


                <ZakaCalcTaps {...{ activeComponent, setActiveComponent }} />

                {activeComponent === 'Stock' && <StockZaka />}
                {activeComponent === 'Anam' && <AnamZaka />}
                {activeComponent === 'Gold' && <GoldZaka />}
                {activeComponent === 'Money' && <MoneyZaka />}
            </div>
        </>
    )
}

export default ZakaCalcComponent